<script lang="ts">
  export default {
    emits:['close'],
    methods: {
        closeModal() {
            this.$emit('close');
        },
    },
};
</script>

<template>
    <div class="modal-overlay" @click.self="closeModal">
      <div
        class="modal-content">
      <CloseIcon class="close-button" @click="closeModal"/>
        <slot></slot>
      </div>
    </div>
  </template>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--bg-guide);
    backdrop-filter: blur(10px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
  }
  
  .modal-content {
    width: 1150px; 
    height: 760px; 
    padding: 45px;
    background-color: var(--bg);
    border:1px solid var(--border-text);
    border-radius: 20px;
    position: relative;
  }
  
  .close-button {
    position: absolute;
    color: var(--text);
    top: 0;
    right: 0;
    padding:20px;
    width:60px;
    height:60px;
    background: none;
    border: none;
    cursor: pointer;
  }
  </style>
  